import React, { useContext } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

import AppConst from '../AppLayout/const';
import useStore from '../../states/store';

export default function LogoutDialog() {
  const reset = useStore((state) => state.reset);

  const { toggleLogout, setToggleLogout } = useContext(AppConst.AppContext);
  const handleCancel = () => {
    setToggleLogout(false);
  };

  const handleOk = () => {
    reset();
  };

  return (
    <Dialog open={toggleLogout} onClose={handleCancel}>
      <DialogTitle>Logout</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-logout-description'>
          Are you sure you want to logout?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk}>Ok</Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
